export default __webpack_public_path__ + "static/Tek_Pillar-259a3f85dcaa7f65f09d80f133ce4925.png";